module.exports = __webpack_public_path__ + "static/media/OpenSans-ExtraBold.fb7e3a29.ttf";